(function(){
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('site-nav');
  if(toggle && nav){
    toggle.addEventListener('click', function(){
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Close' : 'Menu';
    });
  }
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var target = 0, current = 0, raf = null;
  function loop(){
    current += (target - current) * 0.08;
    document.documentElement.style.setProperty('--sheen', current.toFixed(2) + '%');
    if(Math.abs(target - current) > 0.05){ raf = requestAnimationFrame(loop); } else { raf = null; }
  }
  window.addEventListener('pointermove', function(e){
    target = (e.clientX / window.innerWidth - 0.5) * 90;
    if(!raf) raf = requestAnimationFrame(loop);
  }, {passive:true});
})();
